import * as Sentry from "@sentry/react";

// Office's browser errors (docs/ARCHITECTURE.md → Error Monitoring; product decision
// 2026-10-09) go to our own GlitchTip through the open-source Sentry SDK. Off without
// VITE_SENTRY_DSN (set at build time). Nothing about staff or requests is collected.
export function initErrorTracking() {
  const dsn = import.meta.env.VITE_SENTRY_DSN as string | undefined;
  if (!dsn) return;
  Sentry.init({
    dsn,
    environment: (import.meta.env.VITE_SENTRY_ENVIRONMENT as string | undefined) ?? "development",
    tracesSampleRate: 0,
    dataCollection: {
      userInfo: false,
      cookies: false,
      httpHeaders: false,
      httpBodies: [],
      urlQueryParams: false,
      databaseQueryData: false,
      stackFrameVariables: false,
    },
    beforeSend(event) {
      if (event.request) {
        delete event.request.cookies;
        delete event.request.headers;
        delete event.request.data;
        delete event.request.query_string;
        // Query strings can carry codes or addresses; the path is enough.
        if (event.request.url) event.request.url = event.request.url.split("?")[0];
      }
      delete event.user;
      return event;
    },
  });
}
